import { styled } from "@mui/material";
import Loader from "../Loader/Loader";
import MapPolygon from "../Maps/MapPolygon";
import StaticMap from "../Maps/StaticMap";

const ContainerStyled = styled("div")({
  width: "100px",
  aspectRatio: 1,
  overflow: "hidden",
});

const MapImageUnstyled = ({ className, polygon }) => (
  <ContainerStyled className={className}>
    {polygon ? (
      <StaticMap LatLngCoords={polygon}>
        <MapPolygon LatLngCoords={polygon} />
      </StaticMap>
    ) : (
      <Loader />
    )}
  </ContainerStyled>
);

const MapImage = styled(MapImageUnstyled)({});

export default MapImage;
